import { CustomDialog } from '../../../../components/CustomDialog';
import { useState } from 'react';
import {
  Button,
  DatePickerController,
} from '../../../../components';
import { downLoadLink } from '../../../../utils/functions/common';
import { useAppDispatch } from '../../../../storeHook';
import { showAlert } from '../../../../services/alert';
import { useLazyGetTransactionReportQuery } from '../../../../services/paymentsDashboard';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import './index.scss';
import { TTransactionReportType } from '../../../../types/paymentsDashboard';
import { RadioGroupController } from '../../../../components/formControllers/appRadioGroup';

export const formSchema = yup.object({
  reportType: yup
    .mixed<TTransactionReportType>()
    .required()
    .default('summary'),
  startDate: yup.date().required('Start Date is required'),
  endDate: yup.date().required('End Date is required'),
});

export type TFilterForm = yup.InferType<typeof formSchema>;

export const TransactionReport: React.FC<{
  enterpriseId: number;
}> = ({ enterpriseId }) => {
  const dispatch = useAppDispatch();
  const [getReport] = useLazyGetTransactionReportQuery();
  const [open, setOpen] = useState(false);

  const formReturn = useForm<TFilterForm>({
    mode: 'onTouched',
    defaultValues: {
      reportType: 'summary',
    },
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = formReturn;

  const onDownloadClick = (data: TFilterForm) => {
    getReport({
      reportType: data.reportType,
      payload: {
        startTimeStamp: dayjs(data.startDate).unix(),
        endTimeStamp: dayjs(data.endDate)
          .add(86399, 's')
          .unix(),
        enterpriseId,
      },
    })
      .unwrap()
      .then((res) => {
        if (res.status == 200) {
          res.url && downLoadLink(res.url);
          dispatch(
            showAlert({
              content:
                'Transaction Report Exported successfully',
            })
          );
        } else {
          dispatch(
            showAlert({
              severity: 'error',
              content: 'No records found',
            })
          );
        }
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  const reportTypeOptions = [
    { value: 'summary', label: 'Summary' },
    { value: 'detailed', label: 'Detailed' },
  ];

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-3"
        variant="button--secondary">
        Transaction Report
      </Button>
      <CustomDialog
        dialogTitle="Transaction Report"
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(onDownloadClick)}
        actionText={{
          submit: 'Download',
          cancel: 'Cancel',
        }}
        maxWidth="sm">
        <div>
          <div className="report-description mt-3">
            This report will give detailed payment breakup
            data including invoice value, deductions like
            tax and commission, payment settled via
            different payment methods etc. on all the orders
            that you have received in the selected time
            period.
          </div>
          <div className="report-description mt-3">
            In instances of multi-part payments for an
            order, report will display the same order
            details multiple times with the relevant
            different transaction details.
          </div>
          <form className="grid grid-cols-2 gap-x-10 mt-3">
            <div className="col-span-2 mb-2">
              <RadioGroupController
                label="Select type of report"
                control={control}
                name="reportType"
                error={errors.reportType?.message}
                options={reportTypeOptions}
              />
            </div>
            <DatePickerController
              label="Payment start Date"
              control={control}
              name="startDate"
              error={errors.startDate?.message}
              selectsStart
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
            <DatePickerController
              label="Payment end Date"
              control={control}
              name="endDate"
              error={errors.endDate?.message}
              selectsEnd
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
          </form>
          <div className="report-note mt-1 mb-3">
            *Report can be downloaded for any 31 days time
            period
          </div>
        </div>
      </CustomDialog>
    </div>
  );
};
